import { SUPPORTED_CHAIN_ID, WALLET_CHAIN_PARAMETERS } from '../chainConfig'

function parseChainId(chainId: string | number | undefined): number | undefined {
  if (typeof chainId === 'number') return chainId
  if (typeof chainId === 'string') {
    return chainId.startsWith('0x') ? parseInt(chainId, 16) : Number(chainId)
  }
  return undefined
}

function isUnknownChainError(error: any): boolean {
  return (
    error?.code === 4902 ||
    error?.data?.code === 4902 ||
    error?.data?.originalError?.code === 4902 ||
    /wallet_addEthereumChain/i.test(error?.message ?? '')
  )
}

export async function requestConfiguredChain(provider: any): Promise<void> {
  if (!provider?.request) return

  const chainId = parseChainId(await provider.request({ method: 'eth_chainId' }).catch(() => undefined))
  if (chainId === SUPPORTED_CHAIN_ID) return

  try {
    await provider.request({
      method: 'wallet_switchEthereumChain',
      params: [{ chainId: WALLET_CHAIN_PARAMETERS.chainId }]
    })
  } catch (error) {
    if (!isUnknownChainError(error)) {
      throw error
    }

    await provider.request({
      method: 'wallet_addEthereumChain',
      params: [WALLET_CHAIN_PARAMETERS]
    })
  }
}
